import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Bars3Icon,
  XMarkIcon,
  HomeIcon,
  UsersIcon,
  BookOpenIcon,
  UserGroupIcon,
  ClipboardDocumentListIcon,
  ArrowUpTrayIcon,
  QuestionMarkCircleIcon,
  ChartBarSquareIcon,
  CalendarDaysIcon,
  DocumentChartBarIcon,
  ArrowsRightLeftIcon,
  DocumentMagnifyingGlassIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';

const AdminNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { path: '/admin/dashboard', label: 'Home', icon: HomeIcon },
    { path: '/admin/dashboard/users', label: 'Users', icon: UsersIcon },
    { path: '/admin/dashboard/courses', label: 'Courses', icon: BookOpenIcon },
    { path: '/admin/dashboard/student-courses', label: 'Student Courses', icon: UserGroupIcon },
    { path: '/admin/dashboard/quizzes', label: 'Quizzes', icon: ClipboardDocumentListIcon },
    { path: '/admin/dashboard/quiz/upload', label: 'Upload Quiz', icon: ArrowUpTrayIcon },
    { path: '/admin/dashboard/past-questions', label: 'Past Questions', icon: QuestionMarkCircleIcon },
   
    { path: '/admin/dashboard/performance', label: 'Performance', icon: ChartBarSquareIcon },
   
    { path: '/admin/dashboard/schedule', label: 'Calendar', icon: CalendarDaysIcon },
    { path: '/admin/dashboard/reports', label: 'Reports', icon: DocumentChartBarIcon },
    { path: '/admin/dashboard/import-export', label: 'Import/Export', icon: ArrowsRightLeftIcon },
    { path: '/admin/dashboard/logs', label: 'Logs', icon: DocumentMagnifyingGlassIcon }
  ];

  const linkClasses = isActive =>
    `inline-flex items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-medium transition ${
      isActive
        ? 'bg-slate-100 text-slate-900 shadow-sm ring-1 ring-white/20'
        : 'text-slate-200 hover:bg-white/10 hover:text-white'
    }`;

  return (
    <nav className="sticky top-0 z-40 border-b border-slate-700/60 bg-gradient-to-r from-slate-800 via-slate-900 to-slate-800 text-white shadow-xl backdrop-blur-sm">
      <div className="max-w-7xl mx-auto">
        <div className="px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
          <NavLink 
            to="/admin/dashboard" 
            className={({ isActive }) => `flex items-center space-x-3 transition-colors duration-300 ${isActive ? 'text-blue-200' : 'hover:text-blue-200'}`}
          >
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-xl flex items-center justify-center shadow-lg ring-1 ring-white/30">
              <ShieldCheckIcon className="h-5 w-5" />
            </div>
            <div>
              <h2 className="text-sm font-semibold">Admin Portal</h2>
              <p className="text-xs text-slate-300">DeBest College Operations</p>
            </div>
          </NavLink>
          
          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-slate-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            aria-label="Toggle navigation"
          >
            {isOpen ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
          </button>
        </div>

        {/* Desktop menu */}
        <div className="hidden md:block px-4 sm:px-6 lg:px-8 pb-4">
          <div className="flex flex-wrap gap-2">
            {menuItems.map((item) => (
              (() => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) => linkClasses(isActive)}
                  >
                    <Icon className="h-4 w-4" />
                    <span>{item.label}</span>
                  </NavLink>
                );
              })()
            ))}
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`md:hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
          <div className="px-4 pb-4 space-y-2 bg-slate-800">
            {menuItems.map((item) => (
              (() => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) => `${linkClasses(isActive)} flex w-full`}
                    onClick={() => setIsOpen(false)}
                  >
                    <Icon className="h-4 w-4" />
                    <span>{item.label}</span>
                  </NavLink>
                );
              })()
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
